export default "__VITE_ASSET__GKgS0ul9__"